﻿import Rest from '@/rest'
import CacheService from '@/common/cache/CacheService'
import { Loading } from 'quasar'

class DataSetService {
    GetSearcher(name) {
        return Rest.Get(`/api/datasets/getsearcher/${name}`);
    }

    GetSearchFields(name) {
        return Rest.Get(`/api/datasets/getsearchfields/${name}`);
    }

    GetDefinition(name) {
        return Rest.Get(`/api/datasets/getdefinition/${name}`);
    }

    GetDataSet(name, ps) {
        return Rest.Post(`/api/datasets/getdataset/${name}`, ps);
    }

    UpdateDataSet(ds) {
        return Rest.Post(`/api/datasets/getdataset/${ds.Name}`, ds.PS);
    }

    CreateDataSet(name, sortField, sortDir, pageSize, search) {
        let ds = {
            Name: name,
            PS: {
                Pager: {
                    SortField: sortField,
                    SortDirection: sortDir,
                    PageIndex: 1,
                    PageSize: pageSize,
                },
                Search: search,
            },
            Results: []
        };

        return ds;
    }

    CreatePS(sortField, sortDir, pageSize, search) {
        let ps = {
            Pager: {
                SortField: sortField,
                SortDirection: sortDir,
                PageIndex: 1,
                PageSize: pageSize,
            },
            Search: search,
        };

        return ps;
    }

    async Export(name, request) {
        try {
            Loading.show();
            var key = await Rest.Post(`/api/datasets/export/${name}`, request);
            CacheService.Download(key);
        } finally {
            Loading.hide();
        }
    }
}

export default new DataSetService();